module.exports = __webpack_public_path__ + "static/spreadsheet-sm-dac3333a6a1fd50e54cfac87195cbdd0.png";